<template>
    <div class="tech-demand-management">
        <!-- 通用表格组件 -->
        <UniversalDataTable
            :columns="techDemandColumns"
            :form-fields="techDemandFormFields"
            :table-data="tableData"
            :pagination="pagination"
            :form-rules="techDemandFormRules"
            :enable-selection="true"
            :enable-edit="true"
            :enable-delete="true"
            :enableCategorySearch="true"
            :categoryOptions=tech_demand_options
            :categoryPlaceholder="'请选择技术领域'"
            :enable-excel-export="true"
            :export-confirm-message="exportMsg"
            @search="handleSearch"
            @create="handleCreate"
            @update="handleUpdate"
            @delete="handleDelete"
            @pagination-change="handlePaginationChange"
            @selection-change="handleSelectionChange"
            @category-change="handleCategoryChange" 
            @export-excel="handleExport"/>
    </div>
</template>

<script>
// 引入通用表格组件和接口
import UniversalDataTable from '@/components/common/commonTable.vue';
import techDemandApi from '@/api/demands.js'; // 技术需求接口（需自行创建）
import { tech_demand_options } from '@/api/base.js';
import { DOWNLOAD_BASE_URL } from '@/api/base.js';
export default {
    name: 'TechDemandManagement',
    components: {
        UniversalDataTable
    },
    data() {
        return {
            // 表格数据
            tableData: [],
            // 分页配置
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            // 搜索关键词
            keyword: '',
            // 错误提示
            error: null,
            tech_demand_options: tech_demand_options,
            keycategory: "",
        };
    },
    computed: {
        //当前筛选信息
        exportMsg() {
            let msg = "";
            if (this.keyword && this.keyword != "") {
                msg += '您筛选的名称为:' + this.keyword + ","
            }
            if (this.keycategory && this.keycategory != "") {
                msg += "您筛选的分类为" + this.keycategory + ","
            }
            msg += "是否确定导出为excel文件？"
            return msg;
        },
        // 分页基础地址
        baseUrl() {
            return `/techDemands?pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}&demandName=${this.keyword}`;
        },
        // 关键词搜索地址（按需求名称搜索）
        keywordUrl() {
            return `/techDemands?demandName=${this.keyword}&pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}&techField=${this.keycategory}`;
        },
        // 表格列配置（对应 TechDemand 实体字段）
        techDemandColumns() {
            return [
                {
                    prop: 'id',
                    label: '需求ID',
                    width: 100,
                    align: 'center'
                },
                {
                    prop: 'demandName',
                    label: '需求名称',
                    width: 220
                },
                {
                    prop: 'techField',
                    label: '技术领域',
                    width: 160,
                    align: 'center'
                },
                {
                    prop: 'demandTypes',
                    label: '需求类型',
                    width: 180,
                    align: 'center',
                    // 数组格式转换为字符串展示
                    formatter: (value) => {
                        if (!value) return '无';
                        // 若后端返回字符串格式（如 "技术开发,技术咨询"）直接展示，若为数组则拼接
                        return Array.isArray(value) ? value.join('、') : value;
                    }
                },
                {
                    prop: 'demandDesc',
                    label: '需求描述',
                    formatter: (value) => {
                        if (!value) return '';
                        return value.length > 15 ? `${value.slice(0, 15)}...` : value;
                    }
                },
                {
                    prop: 'contactPerson',
                    label: '联系人',
                    width: 120,
                    align: 'center'
                },
                {
                    prop: 'contactPhone',
                    label: '联系电话',
                    width: 150,
                    align: 'center'
                },
                {
                    prop: 'techInnovationSubDemand',
                    label: '细分需求',
                    width: 200,
                    formatter: (value) => value || '无'
                },
                {
                    prop: 'companyIntro',
                    label: '公司简介',
                    formatter: (value) => {
                        if (!value) return '';
                        return value.length > 12 ? `${value.slice(0, 12)}...` : value;
                    }
                },
                {
                    prop: 'deadline',
                    label: '截止日期',
                    width: 200,
                    align: 'center',
                    formatter: (value) => {
                        if (!value) return '无';
                        return new Date(value).toLocaleDateString();
                    }
                },
                // {
                //     prop: 'createTime',
                //     label: '创建时间',
                //     width: 200,
                //     align: 'center',
                //     formatter: (value) => {
                //         if (!value) return '';
                //         return new Date(value).toLocaleString();
                //     }
                // },
                // {
                //     prop: 'updateTime',
                //     label: '更新时间',
                //     width: 200,
                //     align: 'center',
                //     formatter: (value) => {
                //         if (!value) return '';
                //         return new Date(value).toLocaleString();
                //     }
                // }
            ];
        },
        // 表单字段配置（新增/编辑弹窗用）
        techDemandFormFields() {
            return [
                {
                    prop: 'demandName',
                    label: '需求名称',
                    type: 'input',
                    required: true,
                    props: {
                        placeholder: '请输入技术需求名称'
                    }
                },
                {
                    prop: 'techField',
                    label: '技术领域',
                    type: 'select',
                    required: true,
                    options: this.tech_demand_options,
                    props: {
                        placeholder: '请选择技术领域'
                    }
                },
                {
                    prop: 'demandTypes',
                    label: '需求类型',
                    type: 'checkbox-group',
                    required: true,
                    options:
                        [
                            { value: '科技金融需求', label: '科技金融需求' },
                            { value: '服务需求', label: '服务需求' },
                            { value: '技术创新需求', label: '技术创新需求' },
                            { value: '成果转化需求', label: '成果转化需求' },
                            { value: '人才需求', label: '人才需求' },
                            { value: '创新平台需求', label: '创新平台需求' }
                        ]
                },
                {
                    prop: 'demandDesc',
                    label: '需求描述',
                    type: 'input',
                    required: true,
                    props: {
                        type: 'textarea',
                        rows: 5,
                        placeholder: '请详细描述技术需求（背景、痛点、期望目标等）'
                    }
                },
                {
                    prop: 'techInnovationSubDemand',
                    label: '科创细分需求',
                    type: 'input',
                    required: false,
                    props: {
                        placeholder: '请输入细分需求（如：算法优化、硬件适配、数据处理等）'
                    }
                },
                {
                    prop: 'companyIntro',
                    label: '公司简介',
                    type: 'input',
                    required: false,
                    props: {
                        type: 'textarea',
                        rows: 3,
                        placeholder: '请简要介绍公司情况（行业、规模、业务范围等）'
                    }
                },
                {
                    prop: 'contactPerson',
                    label: '联系人',
                    type: 'input',
                    required: true,
                    props: {
                        placeholder: '请输入联系人姓名'
                    }
                },
                {
                    prop: 'contactPhone',
                    label: '联系电话',
                    type: 'input',
                    required: true,
                    props: {
                        placeholder: '请输入手机号'
                    },
                    hint: '仅支持中国大陆手机号格式'
                },
                {
                    prop: 'deadline',
                    label: '截止日期',
                    type: 'date-picker',
                    required: false,
                    props: {
                        type: 'date',
                        placeholder: '请选择需求截止日期（非必填）',
                        valueFormat: 'yyyy-MM-dd' // 与后端 LocalDateTime 兼容
                    }
                }
            ];
        },
        // 表单验证规则
        techDemandFormRules() {
            return {
                demandName: [
                    { required: true, message: '请输入需求名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '需求名称长度在2-50个字符之间', trigger: 'blur' }
                ],
                techField: [
                    { required: true, message: '请选择技术领域', trigger: 'change' }
                ],
                demandTypes: [
                    { required: true, message: '请输入需求类型', trigger: 'blur' },
                ],
                demandDesc: [
                    { required: true, message: '请输入需求描述', trigger: 'blur' },
                ],
                contactPerson: [
                    { required: true, message: '请输入联系人', trigger: 'blur' },
                    { min: 2, max: 20, message: '联系人姓名长度在2-20个字符之间', trigger: 'blur' }
                ],
                contactPhone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的中国大陆手机号', trigger: 'blur' }
                ]
            };
        }
    },
    mounted() {
        // 页面加载时获取技术需求列表
        this.loadTechDemandList(this.baseUrl);
    },
    methods: {
        // 加载技术需求列表数据
        async loadTechDemandList(url) {
            try {
                const response = await this.$http.get(url);
                this.pagination.total = response.data.total;
                this.tableData = response.data.records;
                this.error = null;
            } catch (err) {
                this.error = '数据加载失败，请稍后重试';
                console.error('加载技术需求数据出错:', err);
            }
        },

        // 搜索回调（按需求名称关键词搜索）
        handleSearch(keyword) {
            console.log('搜索关键词：', keyword);
            this.keyword = keyword;
            this.pagination.currentPage = 1;
            this.loadTechDemandList(this.keywordUrl);
        },
        //分类切换触发
        handleCategoryChange(val) {
            console.log("切换的技术领域", val)
            this.keycategory = val ? val : "";
            this.loadTechDemandList(this.keywordUrl);
        },

        // 新增技术需求回调
        async handleCreate(formData) {
            console.log('新增技术需求数据：', formData);
            try {
                const res = await techDemandApi.create(formData);
                if (res.code === 200) {
                    this.$message.success(res.msg || '新增技术需求成功');
                    this.loadTechDemandList(this.baseUrl);
                }
            } catch (error) {
                this.$message.error('新增失败：' + (error.msg || '网络错误'));
            }
        },

        // 编辑技术需求回调
        async handleUpdate(formData) {
            try {
                if (!formData.id) {
                    this.$message.error('需求ID不能为空');
                    return;
                }
                const res = await techDemandApi.update(formData);
                if (res.code === 200) {
                    this.$message.success(res.msg || '编辑技术需求成功');
                    this.loadTechDemandList(this.baseUrl);
                }
            } catch (error) {
                this.$message.error('编辑失败：' + (error.msg || '网络错误'));
            }
        },

        // 删除技术需求回调
        async handleDelete(row) {
            console.log('删除技术需求ID：', row.id);
            try {
                const res = await techDemandApi.delete(row.id);
                if (res.code === 200) {
                    this.$message.success(res.msg || '删除技术需求成功');
                    this.loadTechDemandList(this.baseUrl);
                }
            } catch (err) {
                this.$message.error('删除失败：' + (err.msg || '网络错误'));
            }
        },

        // 分页变化回调
        handlePaginationChange(pagination) {
            this.pagination = pagination;
            this.loadTechDemandList(this.keyword ? this.keywordUrl : this.baseUrl);
            console.log('分页变化：', pagination);
        },

        // 选择行变化回调（批量操作用）
        handleSelectionChange(selectedRows) {
            console.log('选中的技术需求：', selectedRows);
            // 可扩展批量删除、批量导出等功能
        },
          //excel导出
        handleExport() {
            this.loadTechDemandList(this.keywordUrl)
            if (this.total == 0) {
                his.$message.error("未找到符合条件的数据信息")
            }
            //发请求导出
            // 2. 拼接请求参数
            const params = new URLSearchParams();
            params.append('projectName', this.keyword || ''); // 你的搜索关键词
            params.append('category', this.keycategory || ''); // 你的分类筛选值


            // 2. 拼接完整的下载URL
            const baseUrl = DOWNLOAD_BASE_URL + '/techDemands/excel'; // 接口路径
            const downloadUrl = `${baseUrl}?${params.toString()}`;

            // 3. 打开新标签页触发下载
            const newTab = window.open(downloadUrl, '_blank');

            // 4. 可选：处理下载失败/无数据的情况（新标签页会显示后端返回的错误信息）
            setTimeout(() => {
                // 如果新标签页没关闭（说明下载没触发，大概率是接口返回了错误）
                if (newTab && !newTab.closed) {
                    // 关闭空标签页
                    // newTab.close();
                    // 提示用户错误信息
                    this.$message.error('导出失败：暂无符合条件的数据');
                }
            }, 2000);
        }
    }
};
</script>

<style scoped>
.tech-demand-management {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

/* 解决表格中超长文本hover提示问题 */
::v-deep .el-table .cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

::v-deep .el-table td {
    position: relative;
}

::v-deep .el-table td:hover .cell {
    white-space: normal;
    overflow: visible;
    background: #fff;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 4px;
    border-radius: 4px;
}
</style>